import { render, staticRenderFns } from "./PaymentRequest.vue?vue&type=template&id=6c9f60ff&scoped=true"
import script from "./PaymentRequest.vue?vue&type=script&lang=js"
export * from "./PaymentRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9f60ff",
  null
  
)

export default component.exports